module.exports = __webpack_public_path__ + "img/download.7cbc7e44.svg";